(ns practitest.frontend.milestone.readiness-index
  (:require [practitest.frontend.components2.dashboard.chart :as chart]
            [practitest.frontend.common.format-utils :as fu]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.milestone.subs :as-alias milestones.subs]
            [practitest.frontend.milestone.readiness-index.subs :as ri.subs]
            [practitest.frontend.common.i18n :refer [format-translation get-translation]]
            [re-frame.core :as rf]))

;; RRQI - Release Readiness Quality Index
(defn planned-vs [{:keys         [start-date end-date]
                   :metrics/keys [executed-per-day]}]
  {:chart/type ::chart/vega
   :mark       :line
   :width      200
   :height     200
   :data       {:executed executed-per-day
                :planned  [{:date start-date :value 0}
                           {:date end-date :value 1}]}
   :encode     {:x {:field :date
                    :type  :temporal
                    :axis  {:label-angle -40
                            :tick-count  10
                            :format      "%y-%m-%d"}}
                :y {:field :value
                    :axis  {:grid true}
                    :type  :quantitative}}})

(def status->label
  #:status
  {:ready       "Ready to Release"
   :in-progress "Release in progress"
   :at-risk     "Not Ready"
   :upcoming    "Not Started"})

(defn- format-metric-value [value]
  (if (some? value)
    (.toFixed value 1)
    "N/A"))

(defn metric-card [{:keys [score-level score label url]}]
  [:a.metric-card {:class score-level :href url}
   [:div.metric-value (format-metric-value score)]
   [:div.metric-label label]])

(defn formatted-period [{:keys [start-date end-date]}]
  (let [s (get-translation "milestone.period" "From: %{from} to: %{to}")]
    (format-translation s {:from (fu/formatted-local-date start-date)
                           :to   (fu/formatted-local-date end-date)})))

(defn formatted-last-update [{:keys [updated_at]}]
  (let [s (get-translation "milestone.last-update" "Last Updated: %{last-update}")]
    (format-translation s {:last-update (fu/formatted-local-date updated_at)})))

(defn card [{:keys [id]}]
  (let [milestone @(rf/subscribe [::ri.subs/milestone id])
        {ms-name       :name
         :keys         [metrics url milestone_status]
         ::keys        [status not-available?]
         :metrics/keys [rrqi]}
        milestone]
    [:div.readiness-card {:class status}
     [:div.header
      [:div.title-section
       [:div.title
        [:a.undecorated-link {:href url}
         [:span ms-name]]
        [:span.status (str " | " milestone_status)]]
       [:div.readiness-status-badge
        (status->label status)]]
      [:div.sub-title (formatted-period milestone)]
      [:div.last-updated
       [icons/small-clock]
       [:span.text (formatted-last-update milestone)]]]
     [:div.side-by-side.content
      [:div.left
       [:f> chart/svg {:chart/type       ::chart/readiness-gauge
                       :rrqi             rrqi
                       :not-available?   not-available?
                       :readiness-status status}]
       [:div.readiness-metrics
        (for [metric metrics]
          ^{:key metric}
          [metric-card metric])]]
      [:div.right.readiness-plan
       [:f> chart/svg (planned-vs milestone)]]]]))
